import PropTypes from 'prop-types'
import React from 'react'
import { categoryPath } from '../../../build/utils/url'
import { fieldsTags, frontmatterCategory } from '../../helpers/markdown'
import VLayout from '../layouts/VLayout'
import TextLink from '../links/TextLink'
import TagList from '../TagList'

const ArticleFooterMeta = ({ article }) => {
  const category = frontmatterCategory(article)
  return (
    <VLayout spacing="none">
      <div>
        Filed Under:{` `}
        <TextLink to={categoryPath(category)}>{category}</TextLink>
      </div>
      <div>
        Tagged With: <TagList tags={fieldsTags(article)} />
      </div>
    </VLayout>
  )
}

ArticleFooterMeta.propTypes = {
  article: PropTypes.object.isRequired,
}

export default ArticleFooterMeta



// WEBPACK FOOTER //
// ./src/components/shared/ArticleFooterMeta/ArticleFooterMeta.jsx